import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33464 5.33329V10.6666H8.0013V5.33329H3.33464ZM4.0013 9.99996V9.56075C4.3596 9.02182 4.97233 8.66663 5.66801 8.66663C6.36364 8.66663 6.97632 9.02177 7.33463 9.56063V9.99996H4.0013ZM4.66801 6.99996C4.66801 6.44767 5.11572 5.99996 5.66801 5.99996C6.22029 5.99996 6.66801 6.44767 6.66801 6.99996C6.66801 7.55224 6.22029 7.99996 5.66801 7.99996C5.11572 7.99996 4.66801 7.55224 4.66801 6.99996Z"
      fill="#261B36"
    />
    <path d="M12.668 7.99996H9.33463V8.66663H12.668V7.99996Z" fill="#261B36" />
    <path d="M9.33463 5.99996H12.668V7.33329H9.33463V5.99996Z" fill="#261B36" />
    <path d="M12.668 9.33329H9.33463V9.99996H12.668V9.33329Z" fill="#261B36" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.667969 4.66663C0.667969 3.56206 1.5634 2.66663 2.66797 2.66663H13.3346C14.4392 2.66663 15.3346 3.56206 15.3346 4.66663V11.3333C15.3346 12.4379 14.4392 13.3333 13.3346 13.3333H2.66797C1.5634 13.3333 0.667969 12.4379 0.667969 11.3333V4.66663ZM2.66797 3.99996H13.3346C13.7028 3.99996 14.0013 4.29844 14.0013 4.66663V11.3333C14.0013 11.7015 13.7028 12 13.3346 12H2.66797C2.29978 12 2.0013 11.7015 2.0013 11.3333V4.66663C2.0013 4.29844 2.29978 3.99996 2.66797 3.99996Z"
      fill="#261B36"
    />
  </svg>
);
